// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentLines_paymentLines__5je-D {
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
}
.PaymentLines_paymentLines__5je-D::before {
  content: "";
  width: 1px;
  height: 100%;
  background-color: var(--border);
  position: absolute;
  left: 4px;
  top: 14px;
}
.PaymentLines_paymentLines__5je-D li {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 4px;
  position: relative;
  z-index: 1;
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--primary-Text);
}
.PaymentLines_paymentLines__5je-D li span {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.PaymentLines_paymentLines__5je-D li::before {
  content: "";
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-right: 4px;
  background-color: var(--brand);
  border: 2px solid var(--white);
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/PaymentLines/PaymentLines.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AACD;AACC;EACC,WAAA;EACA,UAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AACF;AAEC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EAEA,4BAAA;EACA,gBAAA;EACA,0BAAA;AADF;AAGE;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AADH;AAIE;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,8BAAA;EACA,8BAAA;AAFH","sourcesContent":[".paymentLines {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 16px;\r\n\tposition: relative;\r\n\r\n\t&::before {\r\n\t\tcontent: '';\r\n\t\twidth: 1px;\r\n\t\theight: 100%;\r\n\t\tbackground-color: var(--border);\r\n\t\tposition: absolute;\r\n\t\tleft: 4px;\r\n\t\ttop: 14px;\r\n\t}\r\n\r\n\tli {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: start;\r\n\t\talign-items: center;\r\n\t\tgap: 4px;\r\n\t\tposition: relative;\r\n\t\tz-index: 1;\r\n\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 400;\r\n\t\tcolor: var(--primary-Text);\r\n\r\n\t\tspan {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t}\r\n\r\n\t\t&::before {\r\n\t\t\tcontent: '';\r\n\t\t\twidth: 9px;\r\n\t\t\theight: 9px;\r\n\t\t\tborder-radius: 50%;\r\n\t\t\tmargin-right: 4px;\r\n\t\t\tbackground-color: var(--brand);\r\n\t\t\tborder: 2px solid var(--white);\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentLines": `PaymentLines_paymentLines__5je-D`
};
export default ___CSS_LOADER_EXPORT___;
